export default __webpack_public_path__ + "static/media/login.9033f36e.png";